/**
 * Modulo Deblistering: accesso abilitato a tutti gli utenti autenticati.
 * Passare l'oggetto `user` da useAuth().
 */
export function canAccessDeblistering(user) {
  return !!user;
}
